/**
 * Public surface for the listing-variant system.
 *
 * Components consume the resolver via this barrel:
 *   import { resolveListingVariant } from 'src/lib/listingVariants'
 *
 * Tree-shake guarantee: nothing in this module imports React, Apollo,
 * or MUI. Keep it that way — components requiring React context get
 * their own provider entry (Unit 2's `ListingVariantProvider`).
 */

export type {
  AdminPanelConfig,
  BaseListingVariant,
  CheckoutAuthGate,
  CheckoutConfig,
  CtaAction,
  CtaConfig,
  I18nKey,
  LeadFormChannel,
  LeadFormConfig,
  LeadFormField,
  LeadFormFieldName,
  LeadFormMethod,
  LeadFormQualifier,
  LeadFormStep,
  LeadType,
  ListingVariant,
  ListingVariantMeta,
  PriceCardConfig,
  SectionsConfig,
  SpecialistKey,
  TrustSignalKey,
  VariantKey
} from 'src/lib/listingVariants/types'

export {
  FLEET_TRIGGER_AVAILABILITY_THRESHOLD,
  listingDisclosesHost,
  resolveListingVariant,
  scrubHostIdentity
} from 'src/lib/listingVariants/resolveListingVariant'
export type { IUserLike } from 'src/lib/listingVariants/resolveListingVariant'

export { baseBrokerVariant } from 'src/lib/listingVariants/variants/broker'
export { baseFleetVariant } from 'src/lib/listingVariants/variants/fleet'
export { baseMonthlyVariant } from 'src/lib/listingVariants/variants/monthly'
export { baseTraditionalVariant } from 'src/lib/listingVariants/variants/traditional'

export {
  ListingVariantProvider,
  useListingVariant,
  useVariantSlice
} from 'src/lib/listingVariants/ListingVariantProvider'
